<div
  *ngIf="dataSource && dataSource.filteredData.length > 0"
  class="table-bottom"
>
  <!-- Table Info -->
  <div class="table-bottom-info">
    {{ currentPage === 0 ? 1 : currentPage * itemsPerPage }}-{{
      dataSource.filteredData.length < itemsPerPage
        ? totalTableItems
        : (currentPage + 1) * itemsPerPage
    }}
    de {{ totalTableItems }} resultados
  </div>

  <!-- Paginator -->
  <ul class="paginator">
    <li
      *ngFor="let item of tablePaginator; let i = index"
      (click)="onPaginationItemClicked(item)"
      [ngClass]="item.class"
      [class.disabled]="item.disabled"
    >
      <i *ngIf="item.icon" class="fas" [ngClass]="item.icon"></i>
      <span *ngIf="!item.icon">{{ item.action }}</span>
    </li>
  </ul>
</div>

<!-- Loading -->
<div *ngIf="!dataSource" class="status-message">Cargando...</div>
<!-- No records found -->
<div
  *ngIf="dataSource && dataSource.filteredData.length === 0"
  class="status-message"
>
  No se encontraron resultados.
</div>
